import React, { useState } from "react";
import CreditAgent from "../components/ui/CreditAgent";
import Faq from "../components/ui/Faq";
import HelpCenterSupport from "../components/ui/HelpCenterSupport";

function HelpCenter() {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: "Your Credit Agent",
      content: <CreditAgent />,
    },
    {
      title: "Support",
      content: <HelpCenterSupport />,
    },
    {
      title: "Faq",
      content: <Faq />,
    },
  ];

  return (
    <div className="page_overflow">
      <section className="repair_credit">
        <div className="container">
          <div className="section_title">
            <h2>My Account</h2>
          </div>
          <div className="tabs-container">
            <div className="tabs">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`tab ${activeTab === index ? "active" : ""}`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            <div className="tab-content">{tabs[activeTab].content}</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HelpCenter;
